export const View = () => import("./View.vue");
export const Create = () => import("./Create.vue");
export const OldBill = () => import("./OldBill.vue");
export const BankTransfer = () => import("./BankTransfer.vue");
